var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46978 5.52941C5.07638 9.13601 10.9238 9.13601 14.5304 5.52941L13.4698 4.46875C10.449 7.48956 5.55126 7.48956 2.53044 4.46875L1.46978 5.52941ZM14.8158 11.4941L13.6678 8.72249L12.2819 9.29652L13.43 12.0682L14.8158 11.4941ZM8.75012 12.9991V9.99908H7.25012V12.9991H8.75012ZM3.7182 9.29654L2.57015 12.0682L1.18433 11.4941L2.33238 8.72251L3.7182 9.29654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.3e4573e9466453f7a739210d1abb1d2c.svg";
export { ForwardRef as ReactComponent };